import { useQuery } from '@tanstack/react-query';

/**
 * A reusable hook for fetching data from an API
 * @param {string} url - The API endpoint URL
 * @param {Object} options - Additional options for the query
 * @param {string|array} options.queryKey - The query key for caching
 * @param {Object} options.queryConfig - Additional configuration for the useQuery hook
 * @returns {Object} - Returns the query result object
 */
const BASE_URL = 'https://fixauto.md/api/';


export const SERVICE_LIST_QUERY_KEY = ['serviceList'];

export const useFetch = (url, options = {}) => {
  // Generate query key based on URL if not provided
  const queryKey = options.queryKey || ['data', url];

  // Default fetch configuration
  const defaultQueryConfig = {
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  };

  // Merge provided config with defaults
  const queryConfig = { ...defaultQueryConfig, ...options.queryConfig };

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await fetch(BASE_URL.concat(url));
      if (!response.ok) {
        throw new Error(`Network response error: ${response.status}`);
      }
      return response.json();
    },
    ...queryConfig
  });
};
